<template>
  <b-modal id="desire-view-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`"
            @show="onShow">
    <template #modal-title>
      <div class="d-flex">
        <span aria-hidden="true" @click="isViewMode = !isViewMode;" v-if="canSwitch">
          <img src="/images/pencil.svg" alt="">
        </span>
        <span class="modal-title adp-h2 adp-h2__modal" v-if="isViewMode">{{ $t('voc.view_desire') }}</span>
        <span class="modal-title adp-h2 adp-h2__modal" v-else>{{ $t('voc.edit_desire') }}</span>
      </div>
    </template>
    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template v-if="isViewMode">
<!--      <div class="adp-modal-row">-->
<!--        <div class="adp-p adp-p__grey">{{ $t('catalog.type') }}</div>-->
<!--        <div class="adp-p">{{ $t(`idp.${ttype}`) }}</div>-->
<!--      </div>-->
      <div class="adp-modal-row">
        <div class="adp-p adp-p__grey">{{ $t('catalog.author') }}</div>
        <div class="adp-p">{{ $t(whoCreatedEvent) }}</div>
      </div>
      <div class="adp-modal-row">
        <div class="adp-p adp-p__grey">{{ $t('catalog.name') }}</div>
        <div class="adp-p">{{ name }}</div>
      </div>
      <div class="adp-modal-row" v-if="provider">
        <div class="adp-p adp-p__grey">{{ $t('catalog.provider') }}</div>
        <div class="adp-p">{{ providerOptions.find(x => x.code === provider).label }}</div>
      </div>
      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.description') }}</label>
        <div class="adp-p">{{ additional_info }}</div>
      </div>
    </template>
    <template v-else>
<!--      <div class="adp-modal-row">-->
<!--        <div class="adp-p adp-p__grey">{{ $t('catalog.type') }}</div>-->
<!--        <div class="adp-p">{{ $t('idp.wishes') }}</div>-->
<!--      </div>-->
      <div class="adp-modal-row">
        <div class="adp-p adp-p__grey">{{ $t('catalog.author') }}</div>
        <div class="adp-p">{{ $t(whoCreatedEvent) }}</div>
      </div>
      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.name') }}</label>
        <input type="text" v-model="name" class="adp-input adp-input__text" :placeholder="$t('catalog.name_placeholder')">
      </div>
      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.provider') }}</label>
        <v-select :options="providerOptions" v-model="provider" :reduce="option => option.code">
          <template #option="option">
            <span class="adp-p">{{ option.label }}</span>
          </template>
        </v-select>
      </div>
      <div class="adp-modal-row">
        <label class="adp-p adp-p__grey">{{ $t('catalog.description') }}</label>
        <textarea rows="5" v-model="additional_info" class="adp-input adp-input-textarea" :placeholder="$t('modal.description_placeholder')"></textarea>
      </div>
    </template>
    <template #modal-footer v-if="isViewMode">
      <span>&nbsp;</span>
    </template>
    <template #modal-footer v-else>
      <button class="btn adp-btn adp-btn__large" @click="save()">
        {{ $t('voc.save') }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import api from "../../api";

export default {
  name: "DesireViewModal",
  props: {
    activityId: {
      type: Number,
      required: true,
    },
    activityType: {
      type: String,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isViewMode: true,

      ttype: 'wishes',
      name: '',
      provider: '',
      additional_info: '',
      currentRole: '',
      authorRole: '',

      providerOptions: [],
    }
  },
  computed: {
    canSwitch() {
      if (this.isEditable && this.currentRole === this.authorRole && this.authorRole === 'employee') return false;
      if (this.isEditable && this.currentRole === 'employee' && this.authorRole !== 'employee') return false;
      if (this.currentRole === 'manager') return false;
      if (this.currentRole === 'hr') return false;
      return true;
    },
    whoCreatedEvent() {
      if (this.currentRole !== this.authorRole && this.authorRole === 'hr') return 'modal.created_by_hr';
      if (this.currentRole !== this.authorRole && this.authorRole === 'manager') return 'modal.created_by_manager';
      if (this.currentRole !== this.authorRole && this.authorRole === 'employee') return 'modal.created_by_employee';

      return 'modal.created_by_you';
    }
  },
  methods: {
    startEdit(e) {
      e.preventDefault();
      console.log('startEdit');
    },
    async onShow() {
      this.isViewMode = false;
      await (async () => {
        let res = await api.getLearningActivity(this.activityType, this.activityId);

        this.name = res.data.name;
        this.provider = res.data.provider ? res.data.provider : '';
        this.additional_info = res.data.additional_info;
        this.authorRole = res.data.author_role;
        this.currentRole = window.IDP.role;
      })();

      if (this.currentRole === 'employee' && this.authorRole !== 'employee') this.isViewMode = true;
      if (this.currentRole === 'hr' && this.authorRole !== 'hr') this.isViewMode = true;
      if (this.currentRole === 'manager' && this.authorRole !== 'manager') this.isViewMode = true;
    },
    async getProviders() {
      try {
        let res = await api.getProviders();
        this.providerOptions = res.data.data.map(el => {
          return {
            code: el.id,
            label: el[`name_${this.$i18n.locale}`],
          };
        });
      } catch (e) {
        console.error(e);
      }
    },
    async save() {
      let data = {
        id: this.activityId,
        name: this.name,
        provider: this.provider,
        additional_info: this.additional_info,
        role: window.IDP.role
      };

      try {
        let resp = await api.editWish(data);
        if (resp.status === 201) {
          this.$emit('desire-edited');
        }
      } catch (e) {
        console.error(e.response.data);
        this.$toasts.error(JSON.stringify(e.response.data, null, 2), {
          duration: 700000,
        });
      }
    },
  },
  mounted() {
    this.getProviders();
  }
}
</script>
